// Auth Routes
export const ACCOUNT = 'account';
export const SIGNUP = 'signup';
export const SIGNIN = 'signin';
export const SIGNUP_OTP = 'signup-otp';
export const EMAIL_VERIFIED = 'email-verified';
export const PASSWORD_RESET = 'password-reset';
export const PASSWORD_RESET_SUCCESS = 'password-reset-success';
export const FORGOT_PASSWORD = 'forgot-password';
export const FORGOT_PASSWORD_SUCCESS = 'forgot-password-success';
export const LOCUM_SIGNUP = '/account/signup';
export const VIEW_ONLY_JOBS = 'view-only-jobs';
export const VIEW_ONLY_LOCUMS = 'view-only-locums';

// Landing-page routes
export const DASHBOARD = 'dashboard';
export const LOCUMJOBS = 'locum-jobs';
export const APPLICATION = 'application';
export const USERS_SETTINGS = 'settings';
export const NOTIFICATIONS = 'notifications';
export const BOOKMARKS = 'bookmarks';
export const VIEW_ALL_POSTED_JOBS = 'dashboard/view-all-posted-jobs';
export const VIEW_ALL_APPLICANTS = 'dashboard/view-all-applicants';
export const FIND_LOCUM = 'find-locum';
export const INVITED_JOBS = 'invited-jobs';
// Users Dashboard routes
export const USERS_DASHBOARD = 'dashboard';
export const MANAGE_POSTED_JOBS = 'manage-posted-jobs';
export const VIEW_ALL_APPS = 'view-all-apps';

// NotFound
export const NOTFOUND = '404';

export const UNSUBSCRIBE = 'notifications/unsubscribe';

// Referrals
export const REFERRALS = 'referrals';
export const REFERRAL_CAPTURE = 'ref/:code';

// Subscriptions
export const SUBSCRIPTIONS_PLANS = 'subscriptions/plans';
export const SUBSCRIPTIONS_HISTORY = 'subscriptions/billing-history';
export const SUBSCRIPTIONS_CONFIRMATION = 'subscriptions/confirmation';
